import { render, staticRenderFns } from "./orderManageList.vue?vue&type=template&id=af3fc47e&scoped=true"
import script from "./orderManageList.vue?vue&type=script&lang=js"
export * from "./orderManageList.vue?vue&type=script&lang=js"
import style0 from "./orderManageList.vue?vue&type=style&index=0&id=af3fc47e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3fc47e",
  null
  
)

export default component.exports